// extracted by mini-css-extract-plugin
export default {"section":"Christ_section__Kg1ei","container":"Christ_container__DgjRT","container__photo":"Christ_container__photo__2MTKI","photo":"Christ_photo__597L6"};